<script lang="ts">
import { defineComponent } from 'vue';
export default defineComponent({
  name: 'UiSkeletonPaymentAction',
  props: {
    notification: {
      type: Boolean,
      default: false,
    },
    statementOrder: {
      type: Boolean,
      default: false,
    },
    calculator: {
      type: Boolean,
      default: false,
    },
  },
});
</script>

<template>
  <div class="flex justify-end items-center">
    <q-skeleton v-if="calculator" type="rect" height="28px" width="90px" class="ob-mr-md skeleton-loading" />
    <q-skeleton type="rect" class="ob-mr-md skeleton-loading notification-skeleton" />
    <q-skeleton v-if="!notification" type="rect" class="ob-mr-md skeleton-loading import" />
    <q-skeleton v-if="!notification" type="rect" class="skeleton-loading payment payment" />
    <q-skeleton v-if="statementOrder" type="rect" class="ob-mr-md skeleton-loading order" />
  </div>
</template>

<style scoped lang="scss">
.notification-skeleton {
  width: 28px;
  height: 28px;
  @media (min-width: 960px) {
    width: 48px;
    height: 48px;
  }
}
.payment {
  width: 28px;
  height: 28px;
  @media (min-width: 960px) {
    width: 132px;
    height: 48px;
  }
}
.import {
  display: none;
  @media (min-width: 960px) {
    width: 132px;
    height: 48px;
    display: block;
  }
}
.order {
  width: 28px;
  height: 28px;
  @media (min-width: 960px) {
    width: 210px;
    height: 48px;
  }
}
</style>
